import Swal from 'sweetalert2';

global.Swal = Swal.mixin({
  cancelButtonText: '閉じる',
});
